import { InjectableClass } from '@fino/lib-injection';
import { AccountIdValidationService } from '../../domain/accountIdValidation.service';
import { isEmpty } from 'lodash';

const AddressWithNoRules = [/^([A-zäöüÄÖÜß]+( |,|-|_|\.|\(|\)|\/|\\)*)+\d+.*$/];

export class UserFormServiceProvider extends InjectableClass {
  constructor(validationRulesProvider, appCacheProvider) {
    'ngInject';
    super({ validationRulesProvider, appCacheProvider });

    this.activate();
  }

  $get() {
    'ngInject';
    return {
      hasSalutation: this.hasSalutation,
      hasSufficientAge: this.hasSufficientAge,
      isAddressWithHouseNo: this.isAddressWithHouseNo,
    };
  }

  activate() {
    this.validationRulesProvider.addRule('salutation', (value) =>
      this.hasSalutation(value),
    );

    this.validationRulesProvider.addRule('address', (value) =>
      this.isAddressWithHouseNo(value),
    );

    this.validationRulesProvider.addRule('birthday', (value) =>
      this.hasSufficientAge(value),
    );

    this.validationRulesProvider.addRule('postcode', (value) => {
      const { countryCode } = this.appCacheProvider.get('config');
      const pattern = countryCode === 'AT' ? /^\d{4}$/ : /^\d{5}$/;
      return pattern.test(value);
    });

    this.validationRulesProvider.addRule('tin', (value) => {
      const { features } = this.appCacheProvider.get('config');
      const pattern = features.tinValidation;

      return (
        !pattern ||
        isEmpty(pattern) ||
        AccountIdValidationService.fullfillsPattern(value, pattern)
      );
    });
  }

  hasSalutation(salutation) {
    return salutation.$modelValue === '0';
  }

  hasSufficientAge(birthday) {
    let minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 18);

    let maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 120);

    return (
      birthday.getTime() >= maxDate.getTime() ||
      birthday.getTime() <= minDate.getTime()
    );
  }

  isAddressWithHouseNo(address) {
    return address.match(AddressWithNoRules[0]);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/ui/userForm/userForm.service.provider.js